import api from "@/lib/api";

export const createBlog = async (formData) => {
  const res = await api.post("/blogs/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getBlogs = async () => {
  const res = await api.post("/blogs/getAll");
  return res.data;
};

export const getBlogById = async (blog_id) => {
  const res = await api.get(`/blogs/${blog_id}`);
  return res.data;
};

export const deleteBlog = async (blog_id) => {
  const res = await api.post(`/blogs/delete/${blog_id}`);
  return res.data;
};

export const getBlogCount = async () => {
  const res = await api.post("/blogs/getCount");
  return res.data;
};

export const updateBlog = async (formData) => {
  const res = await api.post("/blogs/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};